import { GridCellProps } from '@progress/kendo-react-grid';
import { getBgColor, getIcon } from 'src/utils/icons';
import GridCellBase from '../GridCellBase';
import PopUpContentWrapper from '../PopUpContentWrapper';
import PopUp from '../design-system/PopUp';

const GLCodeFormatErrorCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const errors: string[] = Object.values(dataItem.errors || {}).flat() as string[];
  const warnings: string[] = Object.values(dataItem.warnings || {}).flat() as string[];
  const hasError = !!errors.length;
  const hasWarnings = !!warnings.length;

  return (
    <GridCellBase {...props} className={getBgColor(errors, warnings)} disableToolTip>
      <PopUp
        content={
          <div>
            <PopUpContentWrapper contents={errors} type="Error" />
            <PopUpContentWrapper contents={warnings} type="Warning" />
          </div>
        }
        show={hasError || hasWarnings}
      >
        <div className="flex items-center justify-center">{getIcon(errors, warnings)}</div>
      </PopUp>
    </GridCellBase>
  );
};

export default GLCodeFormatErrorCell;
